import { render, staticRenderFns } from "./RELTicketsPorStatus.vue?vue&type=template&id=271d57ba&scoped=true&"
import script from "./RELTicketsPorStatus.vue?vue&type=script&lang=js&"
export * from "./RELTicketsPorStatus.vue?vue&type=script&lang=js&"
import style0 from "./RELTicketsPorStatus.vue?vue&type=style&index=0&id=271d57ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d57ba",
  null
  
)

export default component.exports